export default __webpack_public_path__ + "static/media/CRES_SOFT[].690a43ea.png";